import { GRAPHQL_URL, requestMiddleware } from './gatewayHelper';
import { GraphQLClient } from 'graphql-request';

// Custom fetch
const customFetchResponse = async (url: RequestInfo | URL, options?: RequestInit) => {
  const response = await fetch(url, options);

  // Capture headers if needed
  const headers: Record<string, string> = {};
  response.headers.forEach((value, key) => {
    headers[key] = value;
  });

  // Clone the response to preserve its methods and properties
  const clonedResponse = response.clone();
  const data = await clonedResponse.text();
  const json = JSON.parse(data);
  const cloneData = JSON.stringify({
    ...json,
    data: {
      ...json.data,
      headers,
    },
  });
  return new Response(cloneData, clonedResponse);
};

export const clientCustomResponse = new GraphQLClient(GRAPHQL_URL, {
  credentials: 'include',
  fetch: customFetchResponse,
  requestMiddleware: requestMiddleware,
});

export function appFetcherCustom<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => clientCustomResponse.request<TData, any>(query, variables);
}
